// extracted by mini-css-extract-plugin
export default {"table":"Orders_table__Ketk7","icons":"Orders_icons__X6n0c","pending":"Orders_pending__YjvJx","delivered":"Orders_delivered__jEpvY"};